export default function getCompetenceTitle(
  name: string,
  arrayIndex: number,
): string {
  const sub = name.split('|');

  return sub[arrayIndex];
}
